module.exports = __webpack_public_path__ + "media/images/gifts/open_end/sug_aberto_4-092ab2b5adf31b8d4af386cc2e431a86.jpg";